<template>
    <LexinKeyboardLangContent :layout_content="getLayout()" :lang_header='getHeader()' @add-to-search="addToSearchInput"></LexinKeyboardLangContent>
</template>
<script>

import LexinKeyboardLangContent from "@/components/LexinKeyboardLangContent.vue";

export default {
    props: [],
    components: {
        LexinKeyboardLangContent
    },

    methods: {
        getHeader(){
            return this.$t('message.keyboard-kurdish-sorani');
        },

        getLayout() {
            let layout = {
                default: [
                    '\u0634 \u0633 \u0698 \u0632 \u0695 \u0631 \u062f \u062e \u062d \u0686',
                    '\u062c \u062a \u067e \u0628 \u0627',
                    '',
                    '\u06ce \u06cc \u06c6 \u0648\u0648 \u0648 \u06d5 \u0647 \u0646 \u0645',
                    '\u06b5 \u0644 \u06af \u06a9 \u0642 \u06a4 \u0641 \u063a \u0639',
                    '',
                    '\u0640',
                ],
                shift: []
            };

            return layout;
        },

        addToSearchInput(value) {
            this.$emit('add-to-search', value);
        }
    }
}
</script>
